import { render, staticRenderFns } from "./labour-resources.vue?vue&type=template&id=ee680a76"
import script from "./labour-resources.vue?vue&type=script&lang=js"
export * from "./labour-resources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports